import styled from '@emotion/styled';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { SpacingScale } from 'ds/theme/spacing';
import CheckmarkIcon from 'assets/svg/checkmark.svg';

interface Spacing {
  top?: SpacingScale;
  bottom?: SpacingScale;
}

interface SpacingProps {
  desktop?: Spacing;
  tablet?: Spacing;
  mobile?: Spacing;
}

export const MAX_CONTENT_WIDTH = 1144;

export const SectionSpace = styled.div<SpacingProps>`
  ${({ theme, desktop }) => desktop && theme.media.showAt({ from: 3 })`
    ${desktop.top && `padding-top: ${theme.spacing(desktop.top)}`};
    ${desktop.bottom && `padding-bottom: ${theme.spacing(desktop.bottom)}`};
  `}
  ${({ theme, tablet }) => tablet && theme.media.showAt({ at: 2 })`
    ${tablet.top && `padding-top: ${theme.spacing(tablet.top)}`};
    ${tablet.bottom && `padding-bottom: ${theme.spacing(tablet.bottom)}`};
  `}
  ${({ theme, mobile }) => mobile && theme.media.showAt({ at: 1 })`
    ${mobile.top && `padding-top: ${theme.spacing(mobile.top)}`};
    ${mobile.bottom && `padding-bottom: ${theme.spacing(mobile.bottom)}`};
  `}
`;

export const SectionTitle = styled.div<{ noMargin?: boolean }>`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-bottom: ${({ theme, noMargin }) => noMargin ? 0 : theme.spacing(1)};
  font-size: ${typographyFontSizeCfg.h3.mobile}px;
  line-height: ${typographyLineHeightCfg.h3.mobile}px;
  ${({ theme, noMargin }) => theme.media.showAt({ from: 2 })`
    margin-bottom: ${noMargin ? 0 : theme.spacing(3)};
    font-size: ${typographyFontSizeCfg.h2.mobile}px;
    line-height: ${typographyLineHeightCfg.h2.mobile}px;
  `}
`;

export const CommonWrapper = styled.div`
  margin: 0 auto;
  max-width: ${MAX_CONTENT_WIDTH}px;
  ${({ theme }) => theme.media.showAt({ to: 3 })`
    padding: 0 ${theme.spacing(3)};
  `}
  & .table-row:first-of-type:last-of-type {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.brand.main};
      }
    }
  }
  & .table-row:not(:first-of-type:last-of-type) {
    &:hover {
      &:before {
        cursor: pointer;
        position: absolute;
        inset: 0 -10px;
        content: '';
        border-radius: ${({ theme }) => theme.borderRadius.tiny};
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
      }
    }
    &:active {
      &:before {
        background: rgba(250, 0, 255, 0.15);
      }
    }
  }
`;

export const OverflowHiddenWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const FooterWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(8)};
  `}
`;

export const MapSwitcherWrapper = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  && > * {
    width: auto;
    padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(2)}`};
  }
`;

export const MobileContactWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

export const MobileContactButtonWrapper = styled.div`
  & > * {
    padding: 0;
  }
  ${({ theme }) => `
    flex-basis: 50%;
    margin: 0 ${theme.spacing(0.5)};
    :first-of-type:last-of-type {
      flex-basis: 100%;
    }
  `}
`;

export const MobileNavSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
  border-top: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const MobileMapWrapper = styled.div``;

export const SocialWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

export const Checkmark = styled(CheckmarkIcon)`
  margin-left: ${({ theme }) => theme.spacing(0.5)};
`;
